import { observer, Provider } from "mobx-react";
import * as React from "react";
import { Area } from "../General/Area";
import { AreaBody } from "../General/AreaBody";
import { FullScreen } from "../General/FullScreen";
import { Toolbar } from "../General/Toolbar";
import * as AreaUiInfo from "../States/AreaUiInfo";
import { ReaderToolbarMode, ReaderToolbarPart } from "./ReaderToolbarPart";

export interface IHtmlViewProps extends AreaUiInfo.IAreaUiInfo {
	id: string;
	docId: string;
	docLanguage: string;
	collectionId: string;
	downloadName: string;
	canDownload: boolean;
	launchFile: string;
	fileName: string;
	originalFilename: string;
	isDeleted: boolean;
}

@observer
export class HtmlView extends React.Component<IHtmlViewProps, {}> {

	render() {

		return <Provider>
			<Area>
				<AreaBody>
					<FullScreen backgroundColor="white">
						<Toolbar>
							<ReaderToolbarPart
								id={this.props.id}
								docId={this.props.docId}
								docLanguage={this.props.docLanguage}
								collectionId={this.props.collectionId}
								downloadName={this.props.downloadName}
								canDownload={this.props.canDownload}
								mode={ReaderToolbarMode.Default}
								fileName={this.props.fileName}
								extension=".zip"
								isDeleted={this.props.isDeleted}
								originalFilename={this.props.originalFilename}
							/>
						</Toolbar>
						{this.props.launchFile ? <iframe className="htmlview" src={encodeURI(`/files/${this.props.id}.zip/${this.props.launchFile}`)} /> : null}
					</FullScreen>
				</AreaBody>
			</Area>
		</Provider>
	}

}